import BaggageForm from "./BaggageForm";
import BaggageList from "./BaggageList";
import BaggageDetail from "./BaggageDetail";

// Главный модуль багажа — индекс раздела /admin/baggages.
// Сегмент "baggages" задаётся родителем в baggages-routes.ts.
export const adminBaggageRoutes = [
  {
    path: "list",
    element: BaggageList,
  },
  {
    path: "add",
    element: BaggageForm,
  },
  {
    path: "edit/:id",
    element: BaggageForm,
  },
  {
    path: "detail/:id",
    element: BaggageDetail,
  },
];
